/*
The standard JS Date.toISOString() function return a _simplified_ version of a ISO 8601 string
that is always in the UTC timezone (as denoted by the final 'Z').
Below function return a string with timezone offset information

Ref.:
 - https://stackoverflow.com/a/17415677
 - https://en.wikipedia.org/wiki/ISO_8601
 */
export function toIsoString(date) {
  const tzo = -date.getTimezoneOffset();
  const dif = tzo >= 0 ? '+' : '-';
  const pad = function(num) {
    return (num < 10 ? '0' : '') + num;
  };
  const tz_h = pad(Math.floor(Math.abs(tzo) / 60));
  const tz_m = pad(Math.abs(tzo) % 60)

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` + // YYYY:mm:DD
    `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}` + // HH:MM:SS
    `${dif}${tz_h}:${tz_m}`;
}

